export default __webpack_public_path__ + "static/Hildangelli-f60999651eb4477b22fdbcc0401510a6.png";